import { PricingSelectorModalProps } from './PricingSelectorModal';

export const pricingModalParser = (
  modalData: Queries.ContentfulModal001,
): PricingSelectorModalProps => {
  const { metadata, content } = modalData;
  const { title, description } = metadata || {};

  const options = content?.map((option) => {
    const { eyebrow } = option || {};
    const { title, context } = option?.metadata || {};

    return {
      title: title || '',
      description: eyebrow || '',
      icon: context?.icon || '',
      slug: context?.slug || '',
    };
  });

  return {
    title: title || '',
    description: description?.description || '',
    options,
  };
};
